<mat-toolbar *ngIf="showBulkActionToolbar" class="bulk-actions-toolbar" [ngClass]="{'bulk-sticky-toolbar' : stickyHeader}">
	<span>
		<span *ngIf="!isAllSelected">{{ numSelectedOnPage }} Selected on this page.&nbsp;</span>
		<span *ngIf="isAllSelected">{{ numSelected }} are selected.&nbsp;</span>
		<span *ngIf="hasMoreThanOnePage" (click)="onSelectAllClicked()">
			<span *ngIf="showSelectedTotal">{{numSelected}} Selected Total.&nbsp;</span>
			<span *ngIf="showSelectAll">
				<span class="select-all">Select all {{ numSelectable }}</span>
				&nbsp;
			</span>
		</span>
		<span *ngIf="showClearAll" class="select-all" (click)="onClearAllClicked()">Clear selection</span>
	</span>
	<span class="spacer"></span>
	<div *ngIf="hideBulkActionButtons !== true">
		<ng-container *ngFor="let action of bulkActions; let i = index; key: 'label'">
			<button linq-button (click)="onBulkActionClick(action)" mat-button [attr.aria-label]="action.label">
				{{ action.label }}
			</button>
		</ng-container>
		<span class="separator"></span>
		<button linq-button (click)="onBulkActionCancel()" mat-button [attr.aria-label]="'Cancel Bulk Actions'">Cancel</button>
	</div>
</mat-toolbar>
<div [ngClass]="{'table-container': !stickyHeader}">
	<table mat-table [dataSource]="dataSource" matSort [matSortActive]="defaultSortField" [matSortDirection]="defaultSortDirection"
		matSortDisableClear [matSortDisabled]="config.sortingDisabled" cdkDropList [cdkDropListData]="dataSource"
		(cdkDropListDropped)="dropTable($event)" [cdkDropListSortPredicate]="config.validateDropPosition" aria-label="List" multiTemplateDataRows>
		<ng-container matColumnDef="select" [sticky]="stickyHeader">
			<th mat-header-cell *matHeaderCellDef>
				<mat-checkbox [disabled]="selectAllDisabled" [indeterminate]="isPageSelectAllIndeterminate" (change)="onPageSelectAllClicked($event)"
					[checked]="isPageSelectAllChecked">
				</mat-checkbox>
			</th>
			<td mat-cell *matCellDef="let row">
				<mat-checkbox (click)="$event.stopPropagation()" (change)="onRowSelected(row)" [checked]="selection.isSelected(row)"
					[disabled]="!checkRowCanBeSelected(row)" [matTooltipDisabled]="checkRowCanBeSelected(row)"
					[matTooltip]="disabledRowCheckBoxTooltip(row)" [aria-label]="checkboxLabel(row)">
				</mat-checkbox>
			</td>
		</ng-container>

		<ng-container matColumnDef="expand">
			<th mat-header-cell *matHeaderCellDef [style.display]="(hasExpandableRows$ | async) ? '' : 'none'">
				<button mat-icon-button *ngIf="collapseRowsEnabled && hasExpanded" (click)="collapseAll()" title="Collapse rows">
					<mat-icon>expand_less</mat-icon>
				</button>
			</th>
			<td mat-cell *matCellDef="let row" [style.display]="(hasExpandableRows$ | async) ? '' : 'none'">
				<ng-container *ngIf="this.config.expandedUseArrowIcons !== true; else expandWithArrows">
					<button mat-icon-button color="primary" (click)="expandCollapse(row)" *ngIf="isExpandable(row)">
						<mat-icon *ngIf="!row.isExpanded">add</mat-icon>
						<mat-icon *ngIf="row.isExpanded">remove</mat-icon>
					</button>
				</ng-container>
				<ng-template #expandWithArrows>
					<button mat-icon-button (click)="expandCollapse(row)" *ngIf="isExpandable(row)">
						<mat-icon *ngIf="!row.isExpanded">expand_more</mat-icon>
						<mat-icon *ngIf="row.isExpanded">expand_less</mat-icon>
					</button>
				</ng-template>
			</td>
		</ng-container>

		<ng-container matColumnDef="editable">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let row">
				<ng-container *ngIf="!isEditable(row)">
					<button *ngIf="allowUpdate(row)" (click)="startEditing(row, $event)" mat-icon-button aria-label="Edit">
						<mat-icon>mode</mat-icon>
					</button>
					<button (click)="deleteRow(row, $event)" *ngIf="allowDelete(row)" mat-icon-button aria-label="Delete">
						<mat-icon>delete</mat-icon>
					</button>
				</ng-container>
				<ng-container *ngIf="isEditable(row)">
					<button (click)="applyEditing(row, $event)" mat-icon-button aria-label="Apply" class="apply-button">
						<mat-icon>done</mat-icon>
					</button>
					<button (click)="rejectEditing(row, $event)" mat-icon-button aria-label="Reject">
						<mat-icon color="warn">block</mat-icon>
					</button>
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="move">
			<th mat-header-cell *matHeaderCellDef>{{dropNameColumn}}</th>
			<td mat-cell *matCellDef="let row">
				<mat-icon cdkDragHandle *ngIf="!isDragDisabled()">swap_vert</mat-icon>
			</td>
		</ng-container>

		<ng-container *ngFor="let column of columns; key: 'key'" [sticky]="isSticky(column)" [matColumnDef]="column.key">

			<!-- Sortable Header -->
			<ng-container *ngIf="!column.disableSort">
				<th mat-header-cell *matHeaderCellDef="let row" mat-sort-header
					[class]="isFunction(column.headerClass) ? column.headerClass(row) : column.headerClass">

					<ng-container *ngIf="isFunction(column.headerTemplate); else normalHeader">
						<ng-container [ngTemplateOutlet]="column.headerTemplate()" [ngTemplateOutletContext]="{ column: column }"></ng-container>
					</ng-container>

					<ng-template #normalHeader>
						{{ renderHeader({ column: column, row: row }) }}
					</ng-template>
				</th>
			</ng-container>

			<!-- Non-sortable Header -->
			<ng-container *ngIf="column.disableSort">
				<th mat-header-cell *matHeaderCellDef="let row"
					[class]="isFunction(column.headerClass) ? column.headerClass(row) : column.headerClass">

					<ng-container *ngIf="isFunction(column.headerTemplate); else normalHeader2">
						<ng-container [ngTemplateOutlet]="column.headerTemplate()" [ngTemplateOutletContext]="{ column: column }"></ng-container>
					</ng-container>

					<ng-template #normalHeader2>
						{{ renderHeader({ column: column, row: row }) }}
					</ng-template>
				</th>
			</ng-container>

			<!-- Cell -->
			<td #cell mat-cell *matCellDef="let row" [class]="isFunction(column.cellClass) ? column.cellClass(row) : column.cellClass">

				<ng-container [ngTemplateOutlet]="getTemplate({ column: column, row: row, cell: cell, isFocused: focusedRow.isSelected(row) })"
					[ngTemplateOutletContext]="{
                    column: column,
                    row: row,
                    cell: cell,
                    isFocused: focusedRow.isSelected(row),
                    fc: getFormControl(row, column)
                  }">
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef class="actions"></th>
			<td (click)="onTableActionsOpened($event, row)" (keydown)="onTableActionsOpened($event, row)" mat-cell *matCellDef="let row">
				<sl-kebab [actions]="actions" [entity]="row"></sl-kebab>
			</td>
		</ng-container>

		<!-- Expanded Content Column - The detail row is made up of this one column -->
		<ng-container matColumnDef="expandedDetail">
			<td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
				<ng-container *ngIf="config.expandedColumns?.length === 1 && config.expandedExcludeSubTable === true; else expandSubTable">
					<ng-template let-column ngFor [ngForOf]="config.expandedColumns">
						<ng-container [ngTemplateOutlet]="
								getTemplate({ column: column, row: element[config.expandedColumnName], isFocused: true, alwaysEditable: false })
							" [ngTemplateOutletContext]="{
								column: column,
								row: element[config.expandedColumnName],
								isFocused: true,
								fc: getFormControl(row, column, true)
							}">
						</ng-container>
					</ng-template>
				</ng-container>
				<ng-template #expandSubTable>
					<table mat-table class="table-striped" [dataSource]="getExpandedDatasource(element)" aria-label="Expanded Details">
						<ng-container *ngFor="let column of config.expandedColumns; key: 'key'" [matColumnDef]="column.key">
							<th style="height: 1px" [class]="isFunction(column.headerClass) ? column.headerClass(row) : column.headerClass"
								mat-header-cell *matHeaderCellDef="let row">
								{{ renderHeader({ column: column, row: row }) }}
							</th>
							<td #subcell [class]="isFunction(column.cellClass) ? column.cellClass(row) : column.cellClass" mat-cell
								*matCellDef="let row">
								<ng-container [ngTemplateOutlet]="
										getTemplate({
											column: column,
											row: row,
											cell: subcell,
											isFocused: true,
											alwaysEditable: isFunction(column.isEditable) ? column.isEditable(row) : column.isEditable
										})
									" [ngTemplateOutletContext]="{
										column: column,
										row: row,
										cell: subcell,
										isFocused: true,
										fc: getFormControl(row, column, true)
									}"></ng-container>
							</td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="displayedColumnsSecondTable"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumnsSecondTable" class="element-row"></tr>
					</table>
				</ng-template>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: stickyHeader"
			[ngClass]="{'bulk-sticky-header' : numSelected > 0 && hideBulkActionToolbar !== true && stickyHeader}"></tr>

		<tr cdkDrag [cdkDragDisabled]="isDragDisabled()" cdkDragLockAxis="y" [cdkDragData]="row" [ngClass]="{
				'linq-table__action-row': isFunction(config.onRowClick),
				editing: this.isEditable(row),
				'selected-row': config.selectedId === row.Id
			}" (click)="onRowClick(row)" mat-row *matRowDef="let row; columns: displayedColumns"></tr>

		<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" [class]="{ expanded: row.isExpanded === true }" class="expanded-row"></tr>

		<tr class="mat-row" *matNoDataRow>
			<td class="mat-cell" colspan="9999">
				{{ dataIsFiltered ? noFilteredDataText : noDataText }}
			</td>
		</tr>
	</table>
</div>

<div [ngClass]="{ paginator__actions: tableActions.length > 0 }" [hidden]="defaultPageSize <= 0 || excludePaginator === true">
	<sl-kebab *ngIf="tableActions.length > 0" label="ACTIONS" icon="expand_more" class="action linq-ml-10" [actions]="tableActions"></sl-kebab>
	<mat-paginator [pageSize]="defaultPageSize" [pageSizeOptions]="pageSizeOptions"> </mat-paginator>
</div>

<!-- Table Cell Templates -->
<!-- This template needs to be on a single line, otherwise a blank space is added to the beginning of the cell -->
<ng-template #text let-row="row" let-column="column">{{ renderTextCell({ column: column, row: row, cell: cell }) }}</ng-template>

<ng-template #checkboxIcon let-row="row" let-column="column">
	<mat-icon [class]="{ 'linq-theme-success': row[column.key] === true }">{{ row[column.key] === true ? 'done' : 'close' }}</mat-icon>
</ng-template>

<ng-template #checkbox let-row="row" let-column="column" let-fc="fc">
	<mat-checkbox *ngIf="!fc" color="primary" [(ngModel)]="row[column.key]" (change)="column?.templateOptions?.onClick()"
		[disabled]="column?.disabled()"></mat-checkbox>
	<mat-checkbox *ngIf="fc" color="primary" [formControl]="fc" [(ngModel)]="row[column.key]" (change)="column?.templateOptions?.onClick()"
		[disabled]="column?.disabled()"></mat-checkbox>
	<mat-error *ngIf="fc?.errors">{{getControlErrorMessage(fc, column)}}</mat-error>
</ng-template>

<ng-template #switch let-row="row" let-column="column" let-fc="fc">
	<mat-slide-toggle *ngIf="!fc" color="primary" [(ngModel)]="row[column.key]"></mat-slide-toggle>
	<mat-slide-toggle *ngIf="fc" color="primary" [formControl]="fc" [(ngModel)]="row[column.key]"></mat-slide-toggle>
	<mat-error *ngIf="fc?.errors">{{getControlErrorMessage(fc, column)}}</mat-error>
</ng-template>

<ng-template #datepicker let-row="row" let-column="column" let-fc="fc">
	<mat-form-field color="accent">
		<input *ngIf="!fc" matInput [(ngModel)]="row[column.key]" [matDatepicker]="dp" />
		<input *ngIf="fc" matInput [formControl]="fc" [matDatepicker]="dp" />
		<mat-datepicker-toggle class="datepicker-toggler" matSuffix [for]="dp"></mat-datepicker-toggle>
		<mat-datepicker #dp panelClass="linq-date-picker"></mat-datepicker>
		<mat-error *ngIf="fc?.errors">{{getControlErrorMessage(fc, column)}}</mat-error>
	</mat-form-field>
</ng-template>

<ng-template #input let-row="row" let-column="column" let-fc="fc">
	<mat-form-field color="accent">
		<input *ngIf="!fc" matInput [(ngModel)]="row[column.key]" />
		<input *ngIf="fc" matInput [formControl]="fc" />
		<mat-error *ngIf="fc?.errors">{{getControlErrorMessage(fc, column)}}</mat-error>
	</mat-form-field>
</ng-template>

<ng-template #select let-row="row" let-column="column">
	<mat-form-field color="accent">
		<mat-select *ngIf="!column.templateOptions?.onChangeUpdateRow" [(ngModel)]="row[column.key]" [required]="column.templateOptions?.required">
			<mat-option *ngFor="let option of column.templateOptions?.options || []; trackByItem" [value]="option.value">
				{{ option.label }}
			</mat-option>
		</mat-select>
		<mat-select *ngIf="column.templateOptions?.onChangeUpdateRow" [(ngModel)]="row[column.key]"
			(ngModelChange)="column.templateOptions?.onChange(row)" [required]="column.templateOptions?.required">
			<mat-option *ngFor="let option of column.templateOptions?.options || []; trackByItem" [value]="option.value">
				{{ option.label }}
			</mat-option>
		</mat-select>
		<mat-error *ngIf="column.templateOptions?.required && row[column.key] === null">{{ column.templateOptions?.errorMessage }}</mat-error>
	</mat-form-field>
</ng-template>
